const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const StudentLink = require("./StudentLink");
const Quad = require("./Quad");
const Sounds = require("../util/Sounds");
const {buttonTypeTable, buttonTypeList} = require("../util/WonkyButtonUtil");
const styles = require("./styles/WonkyButton.css");
const {getBlueLabelSet} = require("../util/QuadUtil");
const {PLAYWRIGHT_TEST_IDS} = require("../../../shared/PlaywrightTestIds");

function getBackgroundClassName({
	variant,
	isDisabled,
	isNonInteractive,
	overrideBGClass,
}) {
	if (overrideBGClass) {
		return overrideBGClass;
	}
	let suffix;
	if (variant === "outline") {
		suffix = "Outline";
	} else if (variant === "primary") {
		suffix = "";
	} else {
		const v = variant || "";
		suffix = v.charAt(0).toUpperCase() + v.slice(1);
	}

	if (isDisabled) {
		return `disabledBg${suffix}`;
	}
	if (isNonInteractive) {
		return `nonInteractiveBg${suffix}`;
	}
	return `bg${suffix}`;
}

module.exports = createReactClass({
	displayName: "WonkyButton",

	propTypes: {
		handleClick: PT.func,
		buttonType: PT.oneOf(buttonTypeList),
		buttonText: PT.string,
		/** Shorter label shown at the narrow breakpoint (850px / 638px height). */
		buttonTextNarrow: PT.string,
		// Only one of leftContent or buttonImageSrc can be provided
		// to specify what appears to the left of the button text:
		leftContent: PT.node,
		buttonImageSrc: PT.string,
		buttonImageOnRight: PT.bool,
		buttonImageSize: PT.number, //in rems
		// Text to be shown under the image and main button text
		extraText: PT.string,
		linkTo: PT.string,
		isExternal: PT.bool,
		isNewTab: PT.bool,
		className: PT.string,
		isDisabled: PT.bool,
		// For no image label only, when not buttonText/type is provided
		quadNum: PT.number,
		noBorder: PT.bool,
		noShadow: PT.bool,
		noSounds: PT.bool,
		tabIndex: PT.number,
		buttonClass: PT.string,
		overrideBGClass: PT.string,
		overrideBorderClass: PT.string,
		overrideTextClass: PT.string,
		overrideImageClass: PT.string,
		forceAutoWidth: PT.bool,
		// TODO: we can take this out when we switch out all shadows to blurry.
		overrideWrapperClass: PT.string,
		// If provided, button computes width as though it were displaying this text.
		overrideButtonTextWidth: PT.string,
		isNonInteractive: PT.bool,
		variant: PT.oneOf(["primary", "secondary", "gray", "outline"]),
		isSmall: PT.bool,
		hidden: PT.bool,
		scale: PT.number,
		fadeIn: PT.bool,
		// If provided, will be passed down to StudentLink / Link
		// to have an additional side effect when user clicks on Link.
		onLinkClick: PT.func,
	},

	getDefaultProps: function() {
		return {
			variant: "primary",
		};
	},

	onClick: function(evt) {
		if (this.props.isDisabled || this.props.isNonInteractive) {
			return;
		}
		if (!this.props.noSounds) {
			if (this.props.buttonType === "keepworking") {
				Sounds.playSound("whoosh");
			}
			if (
				this.props.buttonType !== "submit" &&
				this.props.buttonType !== "saveanswer"
			) {
				Sounds.playSound("button-click");
			}
		}
		this.props.handleClick && this.props.handleClick(evt);
	},

	onKeyDown: function(evt) {
		// Activate on Enter or Space, matching native <button> semantics.
		if (evt.which === 13 || evt.which === 32) {
			if (this.props.isDisabled || this.props.isNonInteractive) {
				return;
			}
			// Space would otherwise scroll the page.
			evt.preventDefault();
			this.onClick();
		}
	},

	sanitizeButtonType: function(buttonType) {
		if (buttonType === "give up") {
			return "giveup";
		}
	},

	getTextLength: function(buttonText, extraText, overrideButtonTextWidth) {
		if (!buttonText && !extraText && !overrideButtonTextWidth) return 0;
		if (overrideButtonTextWidth) {
			return overrideButtonTextWidth.length;
		}

		const divisor = extraText ? 2.1 : 4;
		const textLength = Math.max(
			buttonText.length,
			(extraText || "").length / divisor
		);

		// Makes sure the button is always wide enough since
		// very short button text can lead to the button not being large enough
		// and the text clipping into the border
		// +2 to make some extra padding
		return Math.max(textLength + 2, 8);
	},

	getButtonQuad: function(
		buttonText,
		buttonData,
		linkTo,
		isDisabled,
		extraText,
		overrideButtonTextWidth
	) {
		if (!buttonData) {
			buttonData = {};
		}
		const textLength = this.getTextLength(
			buttonText,
			extraText,
			overrideButtonTextWidth
		);
		let quadFunc = buttonData.quad;
		if (_.isInteger(this.props.quadNum)) {
			quadFunc = getBlueLabelSet(this.props.quadNum);
			buttonData.width = this.props.buttonImageSize + 1;
			buttonData.height = this.props.buttonImageSize + 0.5;
		}
		if (!quadFunc) {
			const dx = Math.max(Math.abs(8 - textLength), 1) / 10;
			quadFunc = (w, h) => [
				dx * w,
				0,
				w - (dx / 2) * w,
				0,
				w,
				h - dx * h,
				dx / 4,
				h,
			];
		}
		const {scale = 1.0} = this.props;
		const heightScale = this.props.extraText ? 1.2 : 1.0;
		const borderWidth = this.props.noBorder ? 0 : 0.6; // in rem
		const height = (buttonData.height || 4) * heightScale;
		const desktopWidth =
			buttonData.width || Math.min(2 * textLength, textLength + 7);
		const scaledWidth = desktopWidth * scale;
		const narrowButtonText = this.props.buttonTextNarrow;
		const narrowTextLength = narrowButtonText
			? this.getTextLength(narrowButtonText, extraText, overrideButtonTextWidth)
			: textLength;
		const narrowWidth =
			buttonData.width ||
			(narrowButtonText
				? Math.min(2 * narrowTextLength, narrowTextLength + 3)
				: desktopWidth);
		const scaledNarrowWidth = narrowWidth * scale;
		const scaledHeight = height * scale;
		const quadStyle = {
			"--wonky-width": scaledWidth + "rem",
			"--wonky-width-narrow": scaledNarrowWidth + "rem",
			"--wonky-height": scaledHeight + "rem",
		};

		let buttonImageEl;
		if (this.props.buttonImageSrc) {
			const imgSize = this.props.buttonImageSize || height - 2;
			let imgClass;
			if (this.props.overrideImageClass) {
				imgClass = this.props.overrideImageClass;
			} else if (!textLength) {
				imgClass = styles.imageOnly;
			} else if (this.props.buttonImageOnRight) {
				imgClass = styles.imageRight;
			} else {
				imgClass = styles.imageLeft;
			}
			const imageStyle = {
				height: imgSize + "rem",
				width: this.props.forceAutoWidth === true ? "auto" : imgSize + "rem",
			};

			buttonImageEl = (
				<img
					className={imgClass}
					src={this.props.buttonImageSrc}
					style={imageStyle}
				/>
			);
		}
		let leftContent = null;
		let rightContent = null;
		if (this.props.leftContent) {
			leftContent = this.props.leftContent || null;
		} else if (buttonImageEl && !this.props.buttonImageOnRight) {
			leftContent = buttonImageEl;
		}
		if (buttonImageEl && this.props.buttonImageOnRight) {
			rightContent = buttonImageEl;
		}

		const isOutline = this.props.variant === "outline";
		let borderClassName;
		if (isDisabled) {
			borderClassName = "disabledBorder";
		} else if (this.props.isNonInteractive) {
			borderClassName = "nonInteractiveBorder";
		} else {
			borderClassName = "border";
		}
		if (this.props.noBorder) {
			borderClassName = "transparent";
		}
		const variantClassPostfix =
			this.props.variant?.charAt(0).toUpperCase() +
			this.props.variant?.slice(1);
		/* outline: white fill with the same blue border stack as primary */
		if (this.props.variant !== "primary" && !isOutline)
			borderClassName += variantClassPostfix;
		const borderClass =
			this.props.overrideBorderClass || styles[borderClassName];

		const backgroundClass = this.props.overrideBGClass
			? this.props.overrideBGClass
			: styles[
					getBackgroundClassName({
						isDisabled,
						isNonInteractive: this.props.isNonInteractive,
						variant: this.props.variant,
						overrideBGClass: this.props.overrideBGClass,
					})
			  ];

		let quadShadowProps = {shadowOffset: 4, shadowOpacity: 0.4};
		if (this.props.noShadow) {
			quadShadowProps = null;
		}

		const quadBody = (
			<div className={styles.quadWrapper} style={quadStyle}>
				<Quad
					quad={quadFunc}
					borderWidths={[borderWidth, borderWidth, borderWidth, borderWidth]}
					borderUnits="rem"
					backgroundClass={
						Array.isArray(backgroundClass)
							? backgroundClass.join(" ")
							: backgroundClass
					}
					borderClass={
						Array.isArray(borderClass) ? borderClass.join(" ") : borderClass
					}
					disabled={isDisabled}
					{...quadShadowProps}
				/>
			</div>
		);

		let wrapperClass;
		if (buttonData.noShadow) wrapperClass = styles.buttonWrapperNoShadow;
		if (this.props.overrideWrapperClass) {
			wrapperClass = this.props.overrideWrapperClass;
		} else if (this.props.isNonInteractive) {
			wrapperClass = styles.buttonWrapperNonInteractive;
		} else if (this.props.isSmall) {
			wrapperClass = styles.buttonWrapperSmall;
		} else {
			wrapperClass = styles.buttonWrapper;
		}

		if (this.props.fadeIn && !this.props.hidden) {
			wrapperClass += " " + styles.fadeIn;
		}

		let textClass = this.props.overrideTextClass;
		if (!textClass) {
			if (this.props.variant === "outline") {
				textClass = isDisabled
					? styles.textOutlineDisabled
					: styles.textOutline;
			} else {
				textClass = styles.text;
			}
		}
		const extraTextContent = this.props.extraText || null;
		let buttonClassName = isDisabled ? styles.buttonDisabled : styles.button;
		buttonClassName += " " + (this.props.buttonClass || "");

		// Keyboard a11y: the button is a <div>, so it needs an explicit tab stop
		// and button semantics. Default into the tab order when interactive; opt
		// out when disabled/non-interactive, or when a linkTo anchor (StudentLink)
		// is the real focusable element. An explicit tabIndex prop always wins.
		const isInert = isDisabled || this.props.isNonInteractive;
		const hasLink = !!this.props.linkTo;
		let resolvedTabIndex = -1;
		if (this.props.tabIndex !== undefined && !isInert && !hasLink) {
			resolvedTabIndex = this.props.tabIndex;
		}

		let innerDiv = (
			<div
				className={buttonClassName}
				onClick={this.onClick}
				tabIndex={resolvedTabIndex}
				role={hasLink ? undefined : "button"}
				aria-disabled={isDisabled || undefined}
				onKeyDown={this.onKeyDown}
				data-testid={PLAYWRIGHT_TEST_IDS.BLUE_BUTTON}
			>
				{quadBody}
				{this.props.children}
			</div>
		);
		if (this.props.linkTo) {
			innerDiv = (
				<StudentLink
					to={linkTo}
					onLinkClick={this.props.onLinkClick}
					isExternal={this.props.isExternal}
					isNewTab={this.props.isNewTab}
					useWonkyCursor={true}
					data-testid={PLAYWRIGHT_TEST_IDS.BLUE_BUTTON}
				>
					{innerDiv}
				</StudentLink>
			);
		}
		let textEl = null;
		if (buttonText && narrowButtonText) {
			textEl = (
				<React.Fragment>
					<div className={`${textClass} ${styles.buttonTextDefault}`}>
						{buttonText}
					</div>
					<div className={`${textClass} ${styles.buttonTextNarrow}`}>
						{narrowButtonText}
					</div>
				</React.Fragment>
			);
		} else if (buttonText) {
			textEl = <div className={textClass}>{buttonText}</div>;
		}

		const lowerContent = this.props.extraText ? (
			<div className={styles.buttonLowerContent}>
				<div className={styles.extraText}>{extraTextContent}</div>
			</div>
		) : null;

		const upperContentClass =
			styles.buttonUpperContent +
			" " +
			(this.props.extraText ? styles.topPadding : "");
		return (
			<div className={wrapperClass}>
				{innerDiv}
				<div className={styles.buttonContentContainer}>
					<div className={upperContentClass}>
						{leftContent}
						{textEl}
						{rightContent}
					</div>
					{lowerContent}
				</div>
			</div>
		);
	},

	render: function() {
		const buttonClass = this.props.className || "";

		const mainClassName =
			styles.main + (this.props.hidden ? " " + styles.hidden : "");
		const disabledClassName = styles.mainDisabled;
		const nonInteractiveClassName = styles.mainNonInteractive;

		const buttonTypeData = buttonTypeTable[this.props.buttonType] || {};
		let mainStyle = null;
		if (_.get(buttonTypeData, "fontSize")) {
			mainStyle = {fontSize: buttonTypeData.fontSize};
		}

		const buttonText = _.isUndefined(this.props.buttonText)
			? buttonTypeData.text
			: this.props.buttonText;
		const extraText = _.isUndefined(this.props.extraText)
			? ""
			: this.props.extraText;

		const buttonImage = this.getButtonQuad(
			buttonText,
			buttonTypeData,
			this.props.linkTo,
			this.props.isDisabled,
			extraText,
			this.props.overrideButtonTextWidth
		);

		if (this.props.isDisabled) {
			return (
				<div
					className={disabledClassName + " " + buttonClass}
					style={mainStyle}
					disabled
				>
					{buttonImage}
				</div>
			);
		} else if (this.props.isNonInteractive) {
			return (
				<div
					className={nonInteractiveClassName + " " + buttonClass}
					style={mainStyle}
				>
					{buttonImage}
				</div>
			);
		} else {
			return (
				<div className={mainClassName + " " + buttonClass} style={mainStyle}>
					{buttonImage}
				</div>
			);
		}
	},
});
